import { User } from "../models/User";
import client from "./axios";

const usersUrl = `${window.__env.BASE_URL}/users`;

interface AvailabilityResponse {
  available: boolean;
}

export const Users = {
  getCurrentUser: () => client.get<User>(`${window.__env.BASE_URL}/me`),
  getUsers: (params?: URLSearchParams) => client.get<any>(usersUrl, { params }),
  getUser: (id: string) => client.get<User>(`${usersUrl}/${id}`),
  createUser: (user: User) => client.post<User>(usersUrl, user),
  updateUser: (user: Partial<User>) => client.put<User>(`${usersUrl}/${user.id}`, user),
  deleteUser: (id: number) => client.delete<User>(`${usersUrl}/${id}`),
  usernameAvailability: (username: string) => client.post<AvailabilityResponse>(`${usersUrl}/username-availability`, { username }),
  resetPassword: (email: string) => client.post(`${window.__env.BASE_URL}/password-reset`, { email }),
  changePassword: (oldPassword: string, newPassword: string) => client.patch(`${window.__env.BASE_URL}/me/password`, { oldPassword, newPassword }),
}